import React from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import SectionHeading from "../components/SectionHeading";
import { ZONES } from "../landingConfig";

/**
 * The Risk Zones deep-dive — the section that sells the product.
 *
 * Left: what the state machine is and what it guarantees.
 * Right: the four zones and what each one means.
 *
 * A worked example of one student moving between zones lives in ProductShots,
 * alongside the class roster.
 */
const BULLETS = ["b1", "b2", "b3", "b4", "b5"];

export default function RiskZones() {
  const { t } = useTranslation();

  return (
    <Section tone="alt">
      <div className="grid gap-12 lg:grid-cols-2 lg:items-centerы lg:gap-16">
        <div>
          <SectionHeading
            eyebrow={t("landing.zones.eyebrow")}
            title={t("landing.zones.h2")}
            sub={t("landing.zones.body")}
          />

          <ul className="mt-8 flex flex-col gap-3">
            {BULLETS.map((key, i) => (
              <li
                key={key}
                className="landing-reveal flex items-start gap-3"
                data-reveal-index={i}
              >
                <Check
                  className="mt-0.5 h-5 w-5 shrink-0 text-primary"
                  aria-hidden="true"
                />
                <span className="leading-relaxed text-black-landing">
                  {t(`landing.zones.${key}`)}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          {/* The four zones and what each one means. */}
          <ul className="flex flex-col gap-4 lg:mt-20">
            {ZONES.map((zone, i) => {
              const { code, bg, Icon, meaning } = zone;
              return (
                <li
                  key={code}
                  className="landing-reveal flex items-start gap-4 rounded-xl border border-line bg-white p-4"
                  data-reveal-index={i}
                >
                  <span
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${bg}`}
                  >
                    <Icon
                      className="h-5 w-5 text-black-landing"
                      aria-hidden="true"
                    />
                  </span>
                  <div>
                    <h3 className="font-semibold text-black-landing">
                      {t(`zones.${code}`)}
                    </h3>
                    <p className="mt-0.5 text-sm leading-relaxed text-muted">
                      {t(`landing.zones.${meaning}`)}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </Section>
  );
}
